module.exports = __webpack_public_path__ + "img/lowtech.7f36e0c4.png";